import './BottomBar.css'
import { FC } from 'react'
import Paper from '@mui/material/Paper'
import { Box, Divider, Toolbar, Typography } from '@mui/material'
import { OraclePrices } from '../OraclePrices/OraclePrices'

export const BottomBar: FC = () => {
  return (
    <>
      <div className="Bottom-spacer-hidden" />
      <Paper elevation={3} className="Bottom-bar">
        <Divider orientation="horizontal" flexItem className={'App-divider'} />
        <Toolbar variant="regular">
          <Box sx={{ flexGrow: 1 }}>
            <OraclePrices />
          </Box>
        </Toolbar>
        <Toolbar className="Bottom-bar-notification" variant="regular">
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              component="div"
              className="Bottom-bar-notification-text"
            >
              THIS IS RUNNING ON DEVNET
              <br />
            </Typography>
          </Box>
        </Toolbar>
      </Paper>
    </>
  )
}
